import React from 'react';
import { Link } from 'react-router-dom';
import Logo from '../common/Logo';
import { Instagram, Twitter, Linkedin, Facebook } from 'lucide-react';
import paymentLogos from '../../assets/payment-logos.png';

const SiteFooter = () => {
    return (
        <footer style={{ background: '#111', color: 'white', padding: '6rem 10% 3rem' }}>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '4rem', marginBottom: '4rem' }}>
                <div style={{ gridColumn: 'span 2' }}>
                    <Link to="/" style={{ display: 'flex', alignItems: 'center', gap: '12px', fontWeight: 600, color: 'var(--primary)', textDecoration: 'none', fontSize: '1.75rem', marginBottom: '1.5rem', fontFamily: 'var(--font-logo)' }}>
                        <Logo size={32} /> <span style={{position: 'relative', top: '2px'}}>ugra</span>
                    </Link>
                        Kafe ve restoranlar icin QR menu, musteri sadakati, siparis yonetimi ve AI destekli isletme yonetim platformu. Bir fraxlabs urunudur.
                    <div style={{ display: 'flex', gap: '1rem', marginTop: '2rem' }}>
                        <a href="#" style={{ color: 'white', background: '#222', padding: '10px', borderRadius: '50%' }}><Instagram size={20} /></a>
                        <a href="#" style={{ color: 'white', background: '#222', padding: '10px', borderRadius: '50%' }}><Twitter size={20} /></a>
                        <a href="#" style={{ color: 'white', background: '#222', padding: '10px', borderRadius: '50%' }}><Linkedin size={20} /></a>
                    </div>
                </div>

                <div>
                    <h4 style={{ fontWeight: 700, marginBottom: '1.5rem' }}>Ürün</h4>
                    <ul style={{ listStyle: 'none', padding: 0, display: 'grid', gap: '0.75rem' }}>
                        <li><Link to="/why-ugra" style={{ color: '#aaa', textDecoration: 'none' }}>Neden ugra?</Link></li>
                        <li><Link to="/#features" style={{ color: '#aaa', textDecoration: 'none' }}>Ozellikler</Link></li>
                        <li><Link to="/pricing" style={{ color: '#aaa', textDecoration: 'none' }}>Fiyatlandirma</Link></li>
                    </ul>
                </div>

                <div>
                    <h4 style={{ fontWeight: 700, marginBottom: '1.5rem' }}>Destek</h4>
                    <ul style={{ listStyle: 'none', padding: 0, display: 'grid', gap: '0.75rem' }}>
                        <li><Link to="/about" style={{ color: '#aaa', textDecoration: 'none' }}>Hakkımızda</Link></li>
                        <li><Link to="/contact" style={{ color: '#aaa', textDecoration: 'none' }}>İletişim</Link></li>
                        <li><a href="https://docs.ugra.io/" target="_blank" rel="noreferrer" style={{ color: '#aaa', textDecoration: 'none' }}>Dokümantasyon</a></li>
                    </ul>
                </div>

                <div>
                    <h4 style={{ fontWeight: 700, marginBottom: '1.5rem' }}>Kurumsal</h4>
                    <ul style={{ listStyle: 'none', padding: 0, display: 'grid', gap: '0.75rem' }}>
                        <li><Link to="/privacy" style={{ color: '#aaa', textDecoration: 'none' }}>Gizlilik Politikası</Link></li>
                        <li><Link to="/kvkk" style={{ color: '#aaa', textDecoration: 'none' }}>KVKK Bilgilendirme</Link></li>
                        <li><Link to="/sales-agreement" style={{ color: '#aaa', textDecoration: 'none' }}>Satış Sözleşmesi</Link></li>
                    </ul>
                </div>
            </div>

            <div style={{ borderTop: '1px solid #222', paddingTop: '2.5rem', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '1.5rem' }}>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
                    <p style={{ color: '#666', fontSize: '0.875rem' }}>
                        © 2026 fraxlabs. Tüm hakları saklıdır.
                    </p>
                    <p style={{ color: '#666', fontSize: '0.875rem' }}>
                        info@ugra.io | Made with coffee in Turkey ☕
                    </p>
                </div>
                <div style={{ padding: '5px 0', display: 'flex', alignItems: 'center' }}>
                    <img src={paymentLogos} alt="Güvenli Ödeme Seçenekleri" style={{ height: '34px' }} />
                </div>
            </div>
        </footer>
    );
};

export default SiteFooter;
